import { render, staticRenderFns } from "./OrganizeMenus.vue?vue&type=template&id=bfc738b2&scoped=true&"
import script from "./OrganizeMenus.vue?vue&type=script&lang=js&"
export * from "./OrganizeMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc738b2",
  null
  
)

export default component.exports